import { BaseBlock } from "./BaseBlock";

/**
 * Блок воспроизведения аудио.
 */
export class AudioBlock extends BaseBlock {

    constructor(
        private readonly src: string
    ) {

        super();

    }

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "task audio-task";

        const audio =
            document.createElement("audio");

        audio.src = this.src;
        audio.controls = true;

        this.root.appendChild(audio);

    }

    public override update(): void {
    }

    public override unmount(): void {

        super.unmount();

    }

}